import React, { useEffect, useMemo } from 'react';
import PropTypes from 'prop-types';
import { useTabsNavigationStore } from '../../../../stores';
import { useApiQuery, useApiPost } from '../../../../api/hooks';
import TeamTabs from './TeamTabs';
import TeamPanel from './TeamPanel';
import './teams.css';

// Раздел «Команды»: вкладки команд + панель выбранной команды.
export default function TeamsContent({ shift }) {
    const selectedTeam = useTabsNavigationStore(state => state.selectedTeam);
    const setTeam = useTabsNavigationStore(state => state.setTeam);

    const { data: smenaData, refetch } = useApiQuery(
        ['smena', shift.id],
        `/api/camps/public/smena/${shift.id}`
    );
    const { data: orgList } = useApiQuery(['org', 'list'], '/api/camps/admin/orgs');

    const teams = useMemo(() => smenaData?.teamSet || [], [smenaData]);

    useEffect(() => {
        if (teams.length > 0 && !selectedTeam) {
            setTeam(teams[0].id);
        }
    }, [teams, selectedTeam, setTeam]);

    const createTeam = useApiPost({
        successMessage: 'Команда создана',
        withPreloader: true,
        onSuccess: (data) => {
            refetch();
            setTeam(data.id);
        }
    });

    const handleCreateTeam = () => {
        createTeam.mutate({ url: '/api/camps/admin/teams/new', params: { smenaId: shift.id } });
    };

    const currentTeam = teams.find(t => t.id === selectedTeam);

    return (
        <section className="content white">
            <TeamTabs teams={teams} selectedTeam={selectedTeam} onSelect={setTeam} onAdd={handleCreateTeam} />
            {currentTeam ? (
                <TeamPanel
                    team={currentTeam}
                    teams={teams}
                    orgList={orgList || []}
                    onSave={refetch}
                    onDelete={() => { setTeam(null); refetch(); }}
                />
            ) : (
                <div className="t-caption">Выберите команду для редактирования</div>
            )}
        </section>
    );
}

TeamsContent.propTypes = {
    shift: PropTypes.shape({ id: PropTypes.number.isRequired }).isRequired
};
